import React from "react";
import { Link } from "gatsby";
import { usePostsData } from "./usePostData";
import { useLocalization } from "../../../contexts/Localization";

export interface Props {
  title: string;
  text: string;
  measureText: string;
}

type Product = {
  uri: string;
  title: string;
};

const ProductsList: React.FC<Props> = ({ title, text, measureText }) => {
  const { language } = useLocalization();
  const products = usePostsData(language);

  return (
    <section className="relative w-full bg-gray-100">
      <div className="md:mx-auto md:max-w-7xl pt-16 pb-24">
        <h3 className="text-4xl text-center mt-0">{title}</h3>
        <p
          className="text-center mx-auto sm:w-2/4 sm:px-0 px-6"
          dangerouslySetInnerHTML={{ __html: text }}
        />

        <h4 className="text-2xl text-center">{measureText}</h4>

        <div className="mt-7 mt-4 flex md:flex-row items-center justify-center flex-wrap mb-12 mt-2 md:mx-0 mx-4">
          {products.map((product: Product, idx: number) => (
            <div className="cursor-pointer m-2" key={idx}>
              <Link to={product.uri}>
                <div className="md:w-full flex items-center justify-center px-8 py-3 text-base font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 md:py-4 md:px-10">
                  {product.title}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsList;
